import Base from './Base';

export default class CrmUser extends Base {
    get fullName() {
        return `${this.first_name} ${this.last_name}`;
    }

    get checkStatus() {
        return Boolean(this.user_id);
    }

    get disabled() {
        return this.checkStatus;
    }

    get color() {
        const palette = [
            '#6372A5',
            '#1D95F2',
            '#10D0AD',
            '#E13466',
            '#FFC422',
            '#FF9423',
            '#A233E1',
        ];

        return palette[this.id % palette.length];
    }
}
